import { ClientConfigProductName } from '@frontend/vanilla/core';

import { clientConfigAppGuard, productUnderMaintenanceGuard } from '../guards';
import { RoutesConfig } from './routes-config';

const routes: RoutesConfig = {
    routes: [
        {
            path: 'poker',
            // eslint-disable-next-line @nx/enforce-module-boundaries
            loadChildren: () => import('../../../poker/app/src/poker.routes').then((t) => t.PokerRoutesModule),
            canActivate: [clientConfigAppGuard, productUnderMaintenanceGuard],
            data: { product: ClientConfigProductName.POKER },
        },
    ],
};

export default routes;
